import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { OnboardingPages } from '../../../../common/src/pages.ts';
import { IOSAppVersionWithPushNotifications, useContainingAppVersion } from '../../util/billing.ts';
import { compareAppVersions, ContainingAppPlatform } from '../../util/containing_app.ts';
import { getPushNotificationsAuthorization, PushNotificationAuthorization } from '../../util/push_notifications.ts';
import { Button } from './button.tsx';
import { Content, goToNextOnboardingStep, Message, setOnboardingHouseholdSurveyResponse } from './common.tsx';
import { Frame } from './frame.tsx';

export const AllowNotifications = () => {
  const navigate = useNavigate();

  const onContinue = useCallback(async () => {
    await goToNextOnboardingStep(navigate, { from: OnboardingPages.AllowNotifications, action: 'continue' });

    // Ideally, we would pop the push notification dialog *before* navigating to the next page.
    // However, iOS occassionally hangs without popping the dialog & without allowing our promise to complete.
    // So... we navigate to the next page *first* to guarantee we don't get stuck and let iOS pop the dialog or not.
    void requestPushNotificationsAuthorization();
  }, [navigate]);

  const containingAppVersion = useContainingAppVersion();
  const hasPushNotifications =
    containingAppVersion?.platform === ContainingAppPlatform.iOS &&
    compareAppVersions(containingAppVersion.version, IOSAppVersionWithPushNotifications) >= 0;

  return (
    <Frame
      onboardingPage={OnboardingPages.AllowNotifications}
      mainContent={
        <>
          <MessageWrapper $widthInChars={20}>
            Awesome, we&apos;ll help make sure you&apos;re two taps away from singing when it&apos;s time.
          </MessageWrapper>
          {hasPushNotifications && (
            <Content>
              <NotificationsImage key="friend" src="/images/notifications.png" />
            </Content>
          )}
        </>
      }
      footerContent={
        <>
          <Button onClick={onContinue}>CONTINUE</Button>
        </>
      }
      onEnterKeypress={onContinue}
    />
  );
};

// The margins below ensure that the notifications dialog underlay image exactly aligns with the actual dialog on iOS
const MessageWrapper = styled(Message)`
  margin-top: 30px;
`;

const NotificationsImage = styled.img`
  margin-top: 25px;
  width: 70%;
  height: auto;
  opacity: 50%;
`;

async function requestPushNotificationsAuthorization() {
  try {
    const authorization = await getPushNotificationsAuthorization({ requestPermission: true });
    console.log(`push notification authorization: ${authorization}`);
    const optedIntoNotifications = authorization === PushNotificationAuthorization.Authorized;
    setOnboardingHouseholdSurveyResponse({ optedIntoNotifications });
  } catch {}
}
